var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "emd-card",
    [
      _c(
        "emd-card-header",
        [
          _c("emd-text", { attrs: { size: "section" } }, [
            _vm._v(" " + _vm._s(_vm.$t("header"))),
          ]),
        ],
        1
      ),
      _c(
        "emd-card-content",
        [
          _vm.data.creditCard
            ? _c("credit-card", { attrs: { data: _vm.data.creditCard } })
            : _vm._e(),
          _vm.data.boleto
            ? _c("boleto", { attrs: { data: _vm.data.boleto } })
            : _vm._e(),
          _vm.data.pix
            ? _c("pix", { attrs: { data: _vm.data.pix } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }